
import { toast } from "sonner";

export function validateAuthentication(isAuthenticated: boolean, user: any): boolean {
  if (!isAuthenticated || !user) {
    toast.error("Vous devez être connecté pour utiliser l'assistant médical");
    return false;
  }
  return true;
}

export function validateTokens(isAdmin: boolean, hasEnoughTokens: (amount: number) => boolean): boolean {
  if (!isAdmin && !hasEnoughTokens(1)) {
    toast.error("🎁 Token insuffisant. Faites un don via Ko-fi pour obtenir plus de tokens.");
    return false;
  }
  return true;
}

export function validateInput(userInput: string, selectedImage: any): boolean {
  if (!userInput?.trim() && !selectedImage) {
    toast.error("Veuillez entrer un message ou sélectionner une image.");
    return false;
  }
  return true;
}
